import React from 'react';
import { Link } from 'react-router-dom';

function Dashboard() {
    return (
        <div>
            <div className="int-container">
                <div class="container">
                    <div class="form-container-large" style={{ padding: "100px 30px" }}>
                        <div class="row">
                            <div class="form-group">
                                <div className="col-md-8">
                                    <h2 style={{ color: "#fff", width: "100%", marginTop: '20px' }}>Let's Make</h2>
                                    <h2 style={{ color: "#f19f1f", width: "100%" }}>Your Pet healthy</h2>
                                </div>
                                <div className="col-md-4"><br/><br/>
                                    <Link className="btn btn-primary" style={{fontSize: '30px', width: '70%'}} to='#'>911<br />emergency</Link>
                                    {/* <img src="/assets/img/sos.png" class="img-responsive" alt="" /> */}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group" style={{ marginTop: '50px', paddingLeft: '15px' }}>
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/member/pet-profile">Pet Profile</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/member/update-profile">My Profile</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/member/call-history">Call History</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/member/transaction-history">Transaction History</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/member/change-password">Change Password</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;